/* Karamah Jewelry — header bars: stat bar countdown + announcement bar rotator */
(function () {
  'use strict';

  var pad = function (n) {
    return n < 10 ? '0' + n : String(n);
  };

  /* Offset string like "+0200" -> minutes ahead of UTC */
  var offsetToMinutes = function (value) {
    var match = /^([+-])(\d{2})(\d{2})$/.exec((value || '').trim());
    if (!match) return 0;
    var minutes = parseInt(match[2], 10) * 60 + parseInt(match[3], 10);
    return match[1] === '-' ? -minutes : minutes;
  };

  if (!customElements.get('bk-stat-bar')) {
    customElements.define(
      'bk-stat-bar',
      class BkStatBar extends HTMLElement {
        connectedCallback() {
          this.root = this.querySelector('.bk-statbar');
          this.fields = {
            days: this.querySelector('[data-bk-days]'),
            hours: this.querySelector('[data-bk-hours]'),
            minutes: this.querySelector('[data-bk-minutes]'),
            seconds: this.querySelector('[data-bk-seconds]')
          };
          this.showDays = this.dataset.showDays === 'true';
          this.offsetMinutes = offsetToMinutes(this.dataset.tzOffset);
          this.target = this.resolveTarget();
          this.tick = this.tick.bind(this);
          this.tick();
          this.timer = setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        resolveTarget() {
          var mode = this.dataset.mode;

          if (mode === 'fixed') {
            var parsed = Date.parse(this.dataset.endsAt || '');
            return isNaN(parsed) ? 0 : parsed;
          }

          if (mode === 'evergreen') {
            var hours = parseFloat(this.dataset.evergreenHours) || 24;
            var key = 'bk-statbar-' + (this.dataset.blockId || 'default');
            var stored = 0;
            try {
              stored = parseInt(window.localStorage.getItem(key), 10);
            } catch (e) {
              stored = 0;
            }
            if (!stored || isNaN(stored) || stored <= Date.now()) {
              stored = Date.now() + hours * 3600000;
              try {
                window.localStorage.setItem(key, String(stored));
              } catch (e) {
                /* storage blocked — the timer still runs for this page view */
              }
            }
            return stored;
          }

          /* daily: next occurrence of the reset time, in the shop's timezone */
          return this.nextDailyReset();
        }

        nextDailyReset() {
          var endHour = parseInt(this.dataset.endHour, 10) || 0;
          var endMinute = parseInt(this.dataset.endMinute, 10) || 0;

          /* By default every visitor counts down to midnight in their own
             timezone, so the bar always reads as "ends today". */
          if (this.dataset.useStoreTz !== 'true') {
            var local = new Date();
            var end = new Date(local.getFullYear(), local.getMonth(), local.getDate(), endHour, endMinute, 0, 0);
            if (end.getTime() <= Date.now()) {
              end = new Date(local.getFullYear(), local.getMonth(), local.getDate() + 1, endHour, endMinute, 0, 0);
            }
            return end.getTime();
          }

          var offsetMs = this.offsetMinutes * 60000;
          var shopNow = new Date(Date.now() + offsetMs);
          var shopEnd = Date.UTC(
            shopNow.getUTCFullYear(),
            shopNow.getUTCMonth(),
            shopNow.getUTCDate(),
            endHour,
            endMinute,
            0
          );
          var target = shopEnd - offsetMs;
          if (target <= Date.now()) target += 86400000;
          return target;
        }

        tick() {
          var remaining = this.target - Date.now();

          if (remaining <= 0) {
            if (this.dataset.mode === 'daily') {
              this.target = this.nextDailyReset();
              remaining = this.target - Date.now();
            } else {
              this.setState('expired');
              clearInterval(this.timer);
              return;
            }
          }

          this.setState('running');

          var totalSeconds = Math.floor(remaining / 1000);
          var days = Math.floor(totalSeconds / 86400);
          var hours = Math.floor((totalSeconds % 86400) / 3600);

          if (!this.showDays) {
            hours += days * 24;
            days = 0;
          }

          if (this.fields.days) this.fields.days.textContent = pad(days);
          if (this.fields.hours) this.fields.hours.textContent = pad(hours);
          if (this.fields.minutes) this.fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
          if (this.fields.seconds) this.fields.seconds.textContent = pad(totalSeconds % 60);
        }

        setState(state) {
          if (this.root && this.root.dataset.state !== state) this.root.dataset.state = state;
        }
      }
    );
  }

  if (!customElements.get('bk-ann-bar')) {
    customElements.define(
      'bk-ann-bar',
      class BkAnnBar extends HTMLElement {
        connectedCallback() {
          this.root = this.querySelector('.bk-annbar');
          this.messages = Array.prototype.slice.call(this.querySelectorAll('.bk-annbar__msg'));
          if (!this.messages.length) return;

          this.index = 0;
          this.messages[0].classList.add('is-active');
          if (this.root) this.root.dataset.init = '1';

          if (this.messages.length < 2) return;

          var interval = (parseFloat(this.dataset.interval) || 4) * 1000;
          this.advance = this.advance.bind(this);
          this.rotator = setInterval(this.advance, interval);

          this.addEventListener('mouseenter', this.pause.bind(this));
          this.addEventListener('mouseleave', this.resume.bind(this));
          this.interval = interval;
        }

        disconnectedCallback() {
          clearInterval(this.rotator);
        }

        pause() {
          clearInterval(this.rotator);
        }

        resume() {
          clearInterval(this.rotator);
          this.rotator = setInterval(this.advance, this.interval);
        }

        advance() {
          var current = this.messages[this.index];
          this.index = (this.index + 1) % this.messages.length;
          var next = this.messages[this.index];

          current.classList.remove('is-active');
          current.classList.add('is-leaving');
          next.classList.remove('is-leaving');
          /* force a reflow so the entry transition starts from below */
          void next.offsetWidth;
          next.classList.add('is-active');

          window.setTimeout(function () {
            current.classList.remove('is-leaving');
          }, 600);
        }
      }
    );
  }
})();
